module.exports = __webpack_public_path__ + "fonts/KaTeX_Caligraphic-Regular.e6fb499f.ttf";